// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"371f9280","453":"0716d1c8","667":"549b1da7","977":"e63e448a"}[chunkId] + ".chunk.js";
};